var alignmentStyle = {"alignLeft":"v9OTJ","textWrapNowrap":"n3WUH","alignRight":"_95xUJ","alignCenter":"eA04W","sizeFullWidth":"g31qc","renderedInTable":"wElUn","sizeOriginal":"OKsqd","sizeContent":"SWTOu","sizeSmall":"mp-8O","sizeSmallCenter":"mKmqO","flex":"ktkTj","LEFT":"V8G41","CENTER":"nZPej","RIGHT":"_7a4a0","AUTO":"SdtJR","JUSTIFY":"e1MZb"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-5e30617e.js.map
